import FormattedMessage from 'I18n/components/FormattedMessage';
import { useChatWidgetLocale } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import styled from 'styled-components';
import { spotlightTheme } from 'conversations-visitor-experience-components/visitor-widget/spotlight/theme';
import QuickReplyButton from 'conversations-visitor-message-history/quick-reply/QuickReplyButton';
import { QUICK_REPLY_VARIANT } from 'conversations-visitor-message-history/quick-reply/constants/quickReplies';
import { getHideNewThreadLink } from '../../query-params/getHideNewThreadLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SpotlightNewThreadPromptContainer = styled.div.withConfig({
  displayName: "SpotlightNewThreadPrompt__SpotlightNewThreadPromptContainer"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:", ";padding:", " ", " ", " ", ";text-align:left;width:100%;"], spotlightTheme.spacing.lg, spotlightTheme.spacing.xxxl, spotlightTheme.spacing.xl, spotlightTheme.spacing.md, spotlightTheme.spacing.xl);
const SpotlightNewThreadPromptHeading = styled.p.withConfig({
  displayName: "SpotlightNewThreadPrompt__SpotlightNewThreadPromptHeading"
})(["margin:0;"]);
function SpotlightNewThreadPrompt({
  createNewThread
}) {
  const locale = useChatWidgetLocale();
  const hideNewThreadLink = getHideNewThreadLink();
  return /*#__PURE__*/_jsxs(SpotlightNewThreadPromptContainer, {
    role: "status",
    children: [/*#__PURE__*/_jsx(SpotlightNewThreadPromptHeading, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.newThreadPromptSpotlight.newHeading",
        options: {
          locale
        }
      })
    }), !hideNewThreadLink && /*#__PURE__*/_jsx(QuickReplyButton, {
      onClick: createNewThread,
      variant: QUICK_REPLY_VARIANT.SPOTLIGHT,
      "data-test-id": "visitor-widget-start-new-thread-button",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.newThreadPromptSpotlight.newButton",
        options: {
          locale
        }
      })
    })]
  });
}
SpotlightNewThreadPrompt.displayName = 'SpotlightNewThreadPrompt';
export default SpotlightNewThreadPrompt;